import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { FiMinus, FiPlus, FiTrash2 } from 'react-icons/fi';
import './CartPage.css';

const CartPage = () => {
  const { cart, loading, updateQuantity, removeFromCart } = useCart();
  const items = cart?.items || [];
  const subtotal = cart?.totalAmount || 0;
  const shipping = subtotal >= 499 ? 0 : 60;
  const total = subtotal + shipping;

  if (loading) return <div className="loading-spinner" style={{paddingTop:'160px'}}><div className="spinner" /></div>;

  if (items.length === 0) {
    return (
      <div className="cart-page">
        <div className="page-header"><h1>Your Cart</h1></div>
        <div className="container">
          <div className="empty-state" style={{padding:'80px 0'}}>
            <div style={{fontSize:'3rem',marginBottom:'16px'}}>🛍️</div>
            <h3>Your cart is empty</h3>
            <p>Discover our beautiful jewellery collection</p>
            <Link to="/shop" className="btn btn-primary" style={{marginTop:'24px'}}>Continue Shopping</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <div className="page-header"><h1>Shopping Cart</h1><p>{items.length} item{items.length !== 1 ? 's' : ''}</p></div>
      <div className="container">
        <div className="cart-layout">
          <div className="cart-items">
            {items.map(item => {
              const product = item.product;
              if (!product) return null;
              const price = item.price;
              return (
                <div key={product._id} className="cart-item">
                  <Link to={`/product/${product._id}`} className="cart-item__image">
                    <img src={product.images?.[0] || 'https://via.placeholder.com/120x160'} alt={product.name} />
                  </Link>
                  <div className="cart-item__info">
                    <Link to={`/product/${product._id}`}><h3>{product.name}</h3></Link>
                    <p className="cart-item__category">{product.category}</p>
                    <div className="cart-item__price">₹{price.toFixed(0)}</div>
                  </div>
                  <div className="cart-item__actions">
                    <div className="qty-control">
                      <button onClick={() => updateQuantity(product._id, item.quantity - 1)} disabled={item.quantity <= 1}><FiMinus size={12} /></button>
                      <span>{item.quantity}</span>
                      <button onClick={() => updateQuantity(product._id, item.quantity + 1)} disabled={item.quantity >= product.stock}><FiPlus size={12} /></button>
                    </div>
                    <div className="cart-item__subtotal">₹{(price * item.quantity).toFixed(0)}</div>
                    <button className="cart-item__remove" onClick={() => removeFromCart(product._id)}><FiTrash2 size={14} /></button>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="cart-summary">
            <h2>Order Summary</h2>
            <div className="summary-row"><span>Subtotal</span><span>₹{subtotal.toFixed(0)}</span></div>
            <div className="summary-row"><span>Shipping</span><span>{shipping === 0 ? <span style={{color:'var(--success)'}}>FREE</span> : `₹${shipping}`}</span></div>
            {shipping > 0 && <p className="free-ship-notice">Add ₹{(499 - subtotal).toFixed(0)} more for free shipping</p>}
            <hr className="divider" style={{margin:'20px 0'}} />
            <div className="summary-row total"><span>Total</span><span>₹{total.toFixed(0)}</span></div>
            <Link to="/checkout" className="btn btn-primary btn-full btn-lg" style={{marginTop:'24px'}}>Proceed to Checkout</Link>
            <Link to="/shop" className="btn btn-outline btn-full" style={{marginTop:'12px'}}>Continue Shopping</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
